import PolicyLayout from "../../components/PolicyLayout/PolicyLayout";
import { PRIVACY_POLICY_COPY } from "../../content/localizedPageCopy";
import { useLocale } from "../../contexts/LocaleContext";

export default function PrivacyPolicy() {
  const { locale } = useLocale();
  const copy = PRIVACY_POLICY_COPY[locale];

  return (
    <PolicyLayout
      badge={copy.badge}
      title={copy.title}
      pageTitle={copy.pageTitle}
      canonicalPath="/privacy-policy"
      description={copy.description}
      summaryTitle={copy.summaryTitle}
      summaryBody={copy.summaryBody}
      sections={copy.sections}
      content={copy.content}
    />
  );
}
